// extracted by mini-css-extract-plugin
export default {"table":"FJsTn4emAJGfrW6CUJYr"};